/** 見つからない画面（住所の打ち間違いなど）。 */
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader.js';

export function NotFoundPage(): ReactNode {
  return (
    <article>
      <PageHeader title="画面が見つかりません" />
      <p>お探しの画面はありません。アドレス（URL）をご確認ください。</p>
      <Link to="/">トップに戻る</Link>
    </article>
  );
}
